import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function FileCard({ imageUrl, format, index }) {
  const {t} = useTranslation();
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "center",
      }}
    >
      {format.toLowerCase() !== "pdf" ? (
        <Box
          sx={{
            borderRadius: "5px",
            border: "1px solid #CAC4D0",
            margin: "1rem 0",
            display: "flex",
            flexDirection: "column",
            justifyContent: "end",
          }}
        >
          <img
            src={
              format.toLowerCase() !== "pdf" ? imageUrl : "/images//pdf.webp"
            }
            alt=""
            width={260}
            className="h-96"
          />
          <Box
            sx={{
              backgroundColor: "#0C72D740",
              padding: "20px",
              backdropFilter: "blur(20px)",
              borderRadius: "15px 15px 0 0",
              display: "flex",
              justifyContent: "space-between",
              position: "absolute",
              width: "260px",
            }}
          >
            <Link to={imageUrl} target="_blank">
              {" "}
              <Typography variant="h5" className="underline">
                {(t("fileCard.file"))}{index}
              </Typography>{" "}
            </Link>
            <Typography variant="h5">{(t("fileCard.format"))}{format.toUpperCase()}</Typography>
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            width: "275px",
            height: "375px",
            borderRadius: "5px",
            border: "1px solid #CAC4D0",
            margin: "1rem 0",
            display: "flex",
            flexDirection: "column",
            justifyContent: "end",
            alignItems: "center",
          }}
        >
          <Box>
            <img
              src={
                format.toLowerCase() !== "pdf" ? imageUrl : "/images//pdf.webp"
              }
              alt=""
              className="h-[23rem]  w-72"
            />
          </Box>

          <Box
            sx={{
              backgroundColor: "#0C72D740",
              padding: "20px",
              backdropFilter: "blur(20px)",
              borderRadius: "15px 15px 0 0",
              display: "flex",
              position: "absolute",
              top: "1",
              justifyContent: "space-between",
              width: "275px",
            }}
          >
            <Link to={imageUrl} target="_blank">
              {" "}
              <Typography variant="h1" className="underline">
              {(t("fileCard.file"))}{index}
              </Typography>{" "}
            </Link>
            <Typography variant="h3"> {(t("fileCard.format"))} {format.toUpperCase()}</Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
}
